import { createQueryParams } from '@/utils/query-params';
import { api } from './index';

const BASE_PATH = '/api/internal/coverage_alerts';

// Mirrors CoverageAlert.resolution_reasons. Covering a slot outside the system is not a
// reason: an alert closes itself once a shift covers its slot.
export type CoverageAlertReason = 'rescheduled' | 'suspended_with_patient' | 'false_alarm' | 'other';

export const COVERAGE_ALERT_REASONS: Array<{ value: CoverageAlertReason; title: string }> = [
  { value: 'rescheduled', title: 'Visita reprogramada' },
  { value: 'suspended_with_patient', title: 'Visita suspendida de acuerdo con el paciente' },
  { value: 'false_alarm', title: 'Falsa alarma' },
  { value: 'other', title: 'Otro' },
];

export type CoverageAlert = {
  id: number;
  aasmState: 'open' | 'covered' | 'dismissed';
  humanAasmState: string;
  patientId: number;
  patientFullName: string;
  groupNames: string[];
  career: string;
  humanCareer: string;
  slotDate: string;
  slotStartsAt: string;
  humanSlotStartsAt: string;
  slotStartTime: string;
  slotEndTime: string | null;
  coveredByShiftId: number | null;
  resolvedAt: string | null;
  humanResolvedAt: string | null;
  resolvedByEmail: string | null;
  resolutionReason: CoverageAlertReason | null;
  humanResolutionReason: string | null;
  resolutionNote: string | null;
};

// The open list is bounded by nature; the resolved one needs both slot dates, at most 93
// days apart (the server answers 400 otherwise).
export type CoverageAlertFilters = {
  status: 'open' | 'resolved';
  from?: string;
  to?: string;
  groupIdIn?: number[];
  careerIn?: string[];
};

export const coverageAlertsApi = {
  index(filters: CoverageAlertFilters): Promise<CoverageAlert[]> {
    return api({ method: 'get', url: `${BASE_PATH}?${createQueryParams(filters)}` })
      .then(response => response.data.coverageAlerts);
  },
  dismiss(
    id: number,
    resolutionReason: CoverageAlertReason,
    resolutionNote: string,
  ): Promise<CoverageAlert> {
    return api({
      method: 'patch',
      url: `${BASE_PATH}/${id}`,
      data: { resolutionReason, resolutionNote },
    }).then(response => response.data.coverageAlert);
  },
};
